import WebReadyImages from "./webReadyImages";

export default WebReadyImages;